import { useEffect, useState, useCallback } from "react";
import { LOCAL_STORAGE_KEYS } from "../constants";
import { clientService } from "../services";

export default function UseClientAuth() {
    const [currentClient, setCurrentClient] = useState(() => {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_CLIENT);
        return raw ? JSON.parse(raw) : null;
    });
    const [initialized, setInitialized] = useState(false);

    const onLogin = useCallback((loginResp, navigate) => {
        const payload = loginResp?.data || loginResp;
        const token = payload?.accessToken || loginResp?.accessToken;
        if (token) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, token);
        }
        const client = { ...payload };
        delete client.accessToken;
        localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_CLIENT, JSON.stringify(client));
        setCurrentClient(client);
        setInitialized(true);
        navigate('/espace-client');
    }, []);

    const onLogout = useCallback(() => {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_CLIENT);
        setCurrentClient(null);
        setInitialized(true);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        if (!token) {
            setInitialized(true);
            return;
        }
        // Rehydrater via le dashboard client
        const cachedClient = localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_CLIENT);
        if (cachedClient) {
            setInitialized(true);
            return;
        }
        (async () => {
            try {
                const resp = await clientService.getDashboard();
                const client = resp?.data?.client;
                if (client) {
                    localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_CLIENT, JSON.stringify(client));
                    setCurrentClient(client);
                }
            } catch {
                // 401 sera gere par APIUtils
            } finally {
                setInitialized(true);
            }
        })();
    }, []);

    const isAuthenticated = !!localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    return { currentClient, setCurrentClient, onLogin, onLogout, isAuthenticated, initialized };
}
